$('.buy-buttons button').hide();
$(function () {
	//カートに入れるの表示切替
	function carbtnShow() {
        $('.buy-buttons button').hide();
		setTimeout(function(){
			var display = "none";
			if($('#BIS_trigger').length){
				display = $('#BIS_trigger').css("display");
			}
			console.log(display);
			if(display=="none"){
				$('.buy-buttons button').show();
			}
			else{
				$('.buy-buttons button').hide();
			}
		},800);
	}
  	
  	carbtnShow();
  	
	$('.variant-picker__option-values').change(function() {
		carbtnShow();
	});	

	//定期便
	$('.regularService_more').click(function(){
		$(this).toggleClass("is-open");
		if($(this).hasClass("is-open")){
			$(this).children(".regularService_more_txt").text("閉じる");
		}
		else{
			$(this).children(".regularService_more_txt").text("もっと詳しく");
		}
		$(this).prev('.regularService_rate').slideToggle();
	});	



});